import type React from "react";
import { ReactComponent as Svg } from "./assets/circle-arrow-out-right.svg";
import * as styles from "./Icon.module.scss";

type CircleArrowOutRightProps = React.SVGProps<SVGSVGElement>;

export const CircleArrowOutRight = ({ className, ...props }: CircleArrowOutRightProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
